export const activity = {
screenTitle: "النشاط",
badgeContractor: "مساحة المقاول",
segmentInbox: "الإشعارات",
segmentFeed: "نشاط مساحة العمل",
notifications: "الإشعارات",
notificationFallback: "إشعار",
recentUpdates: "آخر التحديثات",
fullFeed: "الموجز الكامل",
pendingApproval: "يحتاج إلى ردّك",
reviewRequired: "مراجعة مطلوبة",
inspectionReportMeta: "تقرير الفحص",
viewAsset: "عرض الأصل",
approvedForRepair: "معتمد للإصلاح",
repairsApproved_one: "إصلاح واحد معتمد",
repairsApproved_other: "{{count}} إصلاح معتمد",
createJobs: "إنشاء مهام",
awaitingRecipient: "بانتظار المستلم",
firstShared: "أول مشاركة {{date}}",
resent: "أعيد الإرسال {{date}}",
waitingForReview: "بانتظار المراجعة",
resendDeadline: "إعادة الإرسال وتحديث الموعد",
jobInvitations: "دعوات المهام",
jobFallbackTitle: "مهمة #{{id}}",
acceptOrDecline: "قبول أو رفض",
accept: "قبول",
decline: "رفض",
reportsSharedWithYou: "تقارير تمت مشاركتها معك",
inspectionReportCard: "تقرير الفحص",
emptyInboxTitle: "لا شيء يحتاجك",
emptyInboxSub: "ستظهر هنا الموافقات والدعوات والردود التي تنتظرك.",
feedTitle: "موجز النشاط",
emptyFeedTitle: "لا يوجد نشاط للفريق بعد",
emptyFeedSub: "ستظهر التعيينات وتغييرات الحالة والموافقات هنا.",
events: {
  inspectionSentBack: "أُعيد الفحص للتعديل",
jobAssigned: "تم تعيين المهمة",
jobAssignedTo: "تم تعيين المهمة إلى {{name}}",
jobAccepted: "تم قبول المهمة",
jobRejected: "تم رفض المهمة",
jobRejectedBy: "رفض {{name}} المهمة",
jobStarted: "بدأت المهمة",
jobScheduled: "تمت جدولة المهمة",
jobReportShared: "تمت مشاركة تقرير المهمة",
teamMemberJoined: "انضم إلى الفريق",
jobPaused: "المهمة متوقفة مؤقتًا",
jobResumed: "استؤنفت المهمة",
completionSubmitted: "تم إرسال الإكمال",
jobVerified: "تم التحقق من المهمة",
reworkRequested: "طُلب إعادة العمل",
reworkRequestedBy: "طلب {{name}} إعادة العمل",
evidenceRequested: "طُلب مزيد من الأدلة",
evidenceRequestedBy: "طلب {{name}} مزيدًا من الأدلة",
jobStatusChanged: "المهمة {{status}}",
jobUpdatedFallback: "محدّثة",
contractorInvited: "دعوة مقاول",
contractorAccepted: "قبل المقاول",
contractorDeclined: "رفض المقاول",
quoteRequestSent: "أُرسل طلب عرض سعر",
quoteSubmitted: "أُرسل عرض السعر",
quoteAccepted: "قُبل عرض السعر",
quoteRejected: "رُفض عرض السعر",
quoteDeclined: "رُفض طلب عرض السعر",
contractorAwarded: "تم اختيار المقاول",
inspectionShared: "تمت مشاركة الفحص",
inspectionCompleted: "اكتمل الفحص",
inspectionApproved: "تمت الموافقة على الفحص",
requestCreated: "تم تقديم الطلب",
requestApproved: "تمت الموافقة على الطلب",
requestDeclined: "تم رفض الطلب",
requestConverted: "تحوّل الطلب إلى عمل",
requestClosed: "أُغلق الطلب",
assetDecommissioned: "أُخرج الأصل من الخدمة",
assetRetired: "أُخرج الأصل من الخدمة نهائيًا",
connectedAlert: "تنبيه من جهاز",
assetCreated: "تمت إضافة الأصل",
assetUpdated: "تم تحديث الأصل",
assetDeleted: "تم حذف الأصل",
assetInService: "عاد الأصل إلى الخدمة",
contactAdded: "تمت إضافة جهة اتصال",
contactSharedTeam: "تمت مشاركة جهة الاتصال مع الفريق",
contactPromoted: "تمت ترقية جهة الاتصال إلى الحساب",
contactInvited: "دعوة جهة اتصال",
contactLinked: "ربط جهة اتصال",
assetRelAdded: "إضافة علاقة أصل",
assetRelUpdated: "تحديث علاقة أصل",
assetRelRemoved: "إزالة علاقة أصل",
duplicateMarked: "تعليم أصل مكرر",
canonicalSet: "تعيين الأصل المرجعي",
duplicatesMerged: "دمج أصول مكررة",
approvalWithAsset: "فحص {{asset}} وافق عليه {{recipient}}",
approvalByRecipient: "وافق {{recipient}} على التقرير",
approvalGeneric: "تمت الموافقة على تقرير الفحص",
rejectionWithAsset: "فحص {{asset}} رفضه {{recipient}}",
rejectionByRecipient: "رفض {{recipient}} التقرير",
rejectionGeneric: "تم رفض تقرير الفحص",
},
jobStatus: {
draft: "مسودة",
open: "مفتوح",
accepted: "مقبول",
scheduled: "مجدول",
inProgress: "قيد التنفيذ",
paused: "متوقف مؤقتًا",
completed: "مكتمل",
verified: "مُتحقق",
rejected: "مرفوض",
cancelled: "ملغى",
},
insights: {
  kpiName: {
    portfolio_condition: "الحالة العامة",
    assets_good_condition: "أصول بحالة جيدة",
    inspection_pass_rate: "الفحوصات الناجحة",
    first_time_fix: "أُصلح من المرة الأولى",
    backlog_weeks: "العمل المنتظر (أسابيع)",
    mttr: "متوسط وقت الإصلاح",
    maintenance_approval_turnaround: "وقت الموافقة",
    maintenance_reassignment_rate: "عمل أُعيد إسناده",
    maintenance_reschedule_rate: "الصيانة المعاد جدولتها",
    maintenance_missed_rate: "الصيانة الفائتة",
    maintenance_skip_rate: "الصيانة المتخطاة",
    on_time_completion: "أُنجز في الموعد",
    reactive_vs_planned: "العمل غير المخطط",
    pm_schedule_compliance: "الصيانة المخططة في موعدها",
    cert_currency: "الشهادات السارية",
    statutory_compliance: "الامتثال القانوني",
  },
  kpiTarget: "الهدف {{target}}",
  headlineKpi: {
    health: "الصحة",
    riskLevel: "مستوى المخاطر",
    atRisk: "أصول معرّضة للخطر",
    outOfService: "خارج الخدمة",
    onTime: "في الموعد",
    compliance: "الامتثال",
    ofTotal: "من {{total}}",
    noCompletedJobsWithDueDates: "لا توجد مهام مكتملة لها تواريخ استحقاق",
    nothingToProveYet: "لا يوجد ما يلزم إثباته بعد",
    registerNotLoaded: "لم يُحمَّل سجل الامتثال",
  },
  kpiDetail: {
    requirementsCompliant_zero: "المتطلبات المستوفاة: {{compliant}} من {{count}}",
    requirementsCompliant_one: "المتطلبات المستوفاة: {{compliant}} من {{count}}",
    requirementsCompliant_two: "المتطلبات المستوفاة: {{compliant}} من {{count}}",
    requirementsCompliant_few: "المتطلبات المستوفاة: {{compliant}} من {{count}}",
    requirementsCompliant_many: "المتطلبات المستوفاة: {{compliant}} من {{count}}",
    requirementsCompliant_other: "المتطلبات المستوفاة: {{compliant}} من {{count}}",
    certsCurrent: "الشهادات السارية: {{valid}} من {{total}}",
    onSchedule: "في موعدها: {{completed}} من {{total}}",
    jobsReactive_zero: "المهام غير المخططة: {{reactive}} من {{count}}",
    jobsReactive_one: "المهام غير المخططة: {{reactive}} من {{count}}",
    jobsReactive_two: "المهام غير المخططة: {{reactive}} من {{count}}",
    jobsReactive_few: "المهام غير المخططة: {{reactive}} من {{count}}",
    jobsReactive_many: "المهام غير المخططة: {{reactive}} من {{count}}",
    jobsReactive_other: "المهام غير المخططة: {{reactive}} من {{count}}",
    onTime: "في الموعد: {{onTime}} من {{total}}",
    plannedOccurrences_zero: "مواعيد الصيانة المخططة: {{done}} من {{count}}",
    plannedOccurrences_one: "مواعيد الصيانة المخططة: {{done}} من {{count}}",
    plannedOccurrences_two: "مواعيد الصيانة المخططة: {{done}} من {{count}}",
    plannedOccurrences_few: "مواعيد الصيانة المخططة: {{done}} من {{count}}",
    plannedOccurrences_many: "مواعيد الصيانة المخططة: {{done}} من {{count}}",
    plannedOccurrences_other: "مواعيد الصيانة المخططة: {{done}} من {{count}}",
    pastDueNoDecision: "متأخرة دون قرار: {{missed}} من {{total}}",
    movedWithDelay_zero: "أُعيدت جدولتها: {{moved}} من {{total}}، بمتوسط تأخير {{count}} يوم",
    movedWithDelay_one: "أُعيدت جدولتها: {{moved}} من {{total}}، بمتوسط تأخير يوم واحد",
    movedWithDelay_two: "أُعيدت جدولتها: {{moved}} من {{total}}، بمتوسط تأخير يومين",
    movedWithDelay_few: "أُعيدت جدولتها: {{moved}} من {{total}}، بمتوسط تأخير {{count}} أيام",
    movedWithDelay_many: "أُعيدت جدولتها: {{moved}} من {{total}}، بمتوسط تأخير {{count}} يومًا",
    movedWithDelay_other: "أُعيدت جدولتها: {{moved}} من {{total}}، بمتوسط تأخير {{count}} يوم",
    moved: "أُعيدت جدولتها: {{moved}} من {{total}}",
    decidedWaiting: "تم البت: {{decided}}، بانتظار القرار: {{pending}}",
    decided: "تم البت: {{decided}}",
    completedJobs_zero: "المهام المكتملة: {{count}}",
    completedJobs_one: "المهام المكتملة: {{count}}",
    completedJobs_two: "المهام المكتملة: {{count}}",
    completedJobs_few: "المهام المكتملة: {{count}}",
    completedJobs_many: "المهام المكتملة: {{count}}",
    completedJobs_other: "المهام المكتملة: {{count}}",
    noOpenJobs: "لا توجد مهام مفتوحة",
    noRecentCompletions: "لا توجد مهام مكتملة مؤخرًا لتقدير وتيرة الإنجاز",
    openPerWeek: "مفتوحة: {{open}} · {{rate}} أسبوعيًا",
    reopenedOf: "أُعيد فتحها: {{reopened}} من {{total}}",
    itemsOf_zero: "البنود الناجحة: {{pass}} من {{count}}",
    itemsOf_one: "البنود الناجحة: {{pass}} من {{count}}",
    itemsOf_two: "البنود الناجحة: {{pass}} من {{count}}",
    itemsOf_few: "البنود الناجحة: {{pass}} من {{count}}",
    itemsOf_many: "البنود الناجحة: {{pass}} من {{count}}",
    itemsOf_other: "البنود الناجحة: {{pass}} من {{count}}",
    postureCounts: "جيدة: {{clear}} · للمراقبة: {{watch}} · تتطلب إجراءً: {{action}}",
    atRiskOf: "معرّضة للخطر: {{atRisk}} من {{total}}",
  },
  kpiUnit: {
    days: "{{value}} يوم",
    weeks: "{{value}} أسبوع",
  },
  kpiTargetValue: {
    reactive: "≤ 20% عمل غير مخطط",
    oneDay: "≤ يوم واحد",
    trendDown: "اتجاه نزولي",
    trendUp: "اتجاه صعودي",
    underFourWeeks: "أقل من 4 أسابيع",
    rework: "إعادة العمل ≤ 5%",
  },
  forecast: {
    certificatesLapse_zero: "لا تنتهي صلاحية أي شهادة خلال {{days}} يومًا",
    certificatesLapse_one: "تنتهي صلاحية شهادة واحدة خلال {{days}} يومًا",
    certificatesLapse_two: "تنتهي صلاحية شهادتين خلال {{days}} يومًا",
    certificatesLapse_few: "تنتهي صلاحية {{count}} شهادات خلال {{days}} يومًا",
    certificatesLapse_many: "تنتهي صلاحية {{count}} شهادةً خلال {{days}} يومًا",
    certificatesLapse_other: "تنتهي صلاحية {{count}} شهادة خلال {{days}} يومًا",
    moreSuffix_zero: "+{{count}} أخرى",
    moreSuffix_one: "+{{count}} أخرى",
    moreSuffix_two: "+{{count}} أخرى",
    moreSuffix_few: "+{{count}} أخرى",
    moreSuffix_many: "+{{count}} أخرى",
    moreSuffix_other: "+{{count}} أخرى",
    backlogStalled_zero: "{{count}} مهمة متراكمة لا يجري إنجازها",
    backlogStalled_one: "مهمة واحدة متراكمة لا يجري إنجازها",
    backlogStalled_two: "مهمتان متراكمتان لا يجري إنجازهما",
    backlogStalled_few: "{{count}} مهام متراكمة لا يجري إنجازها",
    backlogStalled_many: "{{count}} مهمةً متراكمة لا يجري إنجازها",
    backlogStalled_other: "{{count}} مهمة متراكمة لا يجري إنجازها",
    backlogStalledDetail: "لم تُنجز أي مهمة خلال الأسابيع الأربعة الماضية — سيستمر تراكم العمل ما لم يُتخذ إجراء.",
    backlogGrowing: "يُتوقع أن يرتفع العمل المتراكم إلى نحو {{projected}} خلال 4 أسابيع",
    backlogGrowingDetail: "يصل {{inflow}} أسبوعيًا مقابل إنجاز {{velocity}} أسبوعيًا — القدرة أقل من الطلب.",
    backlogBurndown: "يُنجز العمل المتراكم خلال نحو {{weeks}} أسبوع بالوتيرة الحالية",
    backlogBurndownDetail: "مفتوحة: {{open}} · يُنجز {{velocity}} أسبوعيًا مقابل وصول {{inflow}} أسبوعيًا.",
    declineTitle: "من المرجح أن ينتقل {{name}} قريبًا إلى «يتطلب إجراء»",
    declineDetailDocument: "حاليًا «للمراقبة» ({{score}}/100)؛ تنتهي صلاحية {{regulation}} خلال 30 يومًا.",
    declineDetailSchedule: "حاليًا «للمراقبة» ({{score}}/100) مع فحص مجدول مستحق أو متأخر.",
  },
  sections: {
    a11y: "أقسام الرؤى",
    workflows: "سير العمل",
    overview: "نظرة عامة",
  },
chart: {
emptyReason: {
noRecords: "لا توجد سجلات متاحة",
noQualifyingRecords: "لا توجد سجلات مؤهلة",
filteredEmpty: "لا توجد تطابقات لهذه المرشحات",
insufficientSample: "لا توجد أدلة كافية حتى الآن",
notApplicable: "لا ينطبق",
loadFailed: "تعذر تحميل بيانات المخطط",
stale: "تحتاج البيانات إلى التحديث",
},
defaultAccessibilityLabel: "مخطط",
},
shell: {
hideDetails: "إخفاء تفاصيل الرؤية",
showDetailsSuffix: "عرض تفاصيل الرؤية.",
expandHint: "انقر نقرًا مزدوجًا لتوسيع لوحة المعلومات الكاملة",
},
conditionPortfolio: {
stableCount_zero: "{{count}} مستقرة.",
stableCount_one: "{{count}} مستقرة.",
stableCount_two: "{{count}} مستقرة.",
stableCount_few: "{{count}} مستقرة.",
stableCount_many: "{{count}} مستقرة.",
stableCount_other: "{{count}} مستقرة.",
band: {
critical: "حرج",
action_recommended: "يوصى بإجراء",
deteriorating: "يتدهور",
watch: "للمراقبة",
stable: "مستقر",
},
bandInfo: {
critical: "أصول تشير أدلتها إلى أنها تحتاج إلى اهتمام الآن: بنود سلامة فاشلة أو عمل عاجل متأخر أو تدهور سريع.",
action_recommended: "أصول تسير في الاتجاه الخاطئ ويُنصح بإجراء مخطط لها قبل أن تصبح حرجة.",
deteriorating: "أصول تُظهر فحوصاتها أو إصلاحاتها أو سجل صيانتها تدهورًا مستمرًا.",
watch: "أصول بها علامة تحذير مبكرة تستحق المراقبة، ولم تتدهور بعد.",
},
noDominantDriver: "لا يوجد عامل رئيسي واحد بارز.",
recurringFault_one: "أصل واحد به عطل متكرر",
recurringFault_other: "{{count}} أصل بها عطل متكرر",
repeatRepairs: "{{count}} بإصلاحات متكررة",
noExceptions: "لا توجد أخطاء متكررة أو إصلاحات متكررة عبر المحفظة.",
noteSuffix: "تظهر إشارات العداد على كل أصل، وليس هنا.",
moreOnList: "+{{count}} المزيد في قائمة الأصول.",
wholeCountsNote: "تشمل الأعداد جميع الأصول، حتى {{date}}. الأصول المدرجة أمثلة من الأصول المحمّلة.",
recurringFault_zero: "لا أصول بها عطل متكرر",
recurringFault_two: "أصلان بهما عطل متكرر",
recurringFault_few: "{{count}} أصول بها عطل متكرر",
recurringFault_many: "{{count}} أصلًا بها عطل متكرر",
},
panel: {
basedOn: "بناءً على: {{source}}",
severityHighPriority: "أولوية عالية",
severityAttention: "الاهتمام",
severityOnTrack: "على المسار الصحيح",
severityFyi: "للعلم",
severityNote: "الملاحظة",
moreItems: "+{{count}} أخرى هنا — نقّح أو ابحث لتضييق النطاق.",
signalsTitle: "الإشارات",
recommendedActionTitle: "الإجراء الموصى به",
},
kpiInfo: {
aboutLabel: "حول {{label}}",
hint: "يفتح شرح لهذا المقياس وكيفية استخدامه",
},
metricInfoSheet: {
dismissOverlay: "تجاهل",
close: "إغلاق",
whatItMeasures: "ما يقيسه",
howToUseIt: "كيفية استخدامه",
basedOn: "على أساس",
asOf: "اعتبارًا من · {{value}}",
target: "الهدف · {{value}}",
},
priorityCard: {
feedbackHelpful: "مفيدة",
feedbackNotUseful: "غير مفيد",
feedbackSnooze: "تأجيل",
feedbackDismiss: "تجاهل",
recommended: "موصى به: {{action}}.",
effort: "الجهد: {{value}}",
expectedBenefit: "الفائدة المتوقعة: {{value}}",
dataGaps: "فجوات البيانات",
butAlso: "لكن أيضًا",
feedbackTrigger: "ملاحظات على الرؤية",
feedbackSheetTitle: "هل كان هذا مفيدًا؟",
},
journeys: {
tabExecutive: "التنفيذي",
tabRequest: "طلب",
tabInspection: "تفتيش",
tabJob: "مهمة",
tabAsset: "أصل",
tabContractor: "متعهد",
tabCompliance: "الامتثال",
tablistLabel: "لوحات معلومات الرحلة",
executiveAssistantTitle: "مساعد تنفيذي",
pageTitle: "تحليلات الرحلة",
journeyCount_one: "{{count}} رحلة",
journeyCount_other: "{{count}} رحلة",
requestFunnel: "مسار الطلب",
journeyFunnel: "مسار الرحلة",
stageFlow: "تدفق المرحلة",
noJourneyFlow: "لا يوجد تدفق للرحلة حتى الآن.",
durationDistribution: "توزيع مدة الرحلة",
noCompletedJourneys: "لا توجد رحلات مكتملة بعد.",
bottlenecksMedianGap: "الاختناقات (وسيط الفجوة بين المراحل)",
bottleneckEmpty: "لم يتم قياس أي شيء حتى الآن. يحتاج الاختناق إلى رحلة واحدة على الأقل أكملت خطوتين متتاليتين (على سبيل المثال طلب ← موافقة).",
workFunnel: "قمع العمل",
bottleneckRanking: "ترتيب عنق الزجاجة",
recentJourneyActivity: "نشاط الرحلة الأخير",
noRecentEvents: "لا توجد أحداث حديثة.",
slaComplianceByStage: "امتثال SLA حسب المرحلة",
slaEmpty: "لم يتم قياس أي شيء حتى الآن. يظهر هذا بمجرد الموافقة على طلب، أو تحويل فحص إلى أمر عمل، أو بدء أمر عمل أو إكماله — فالفجوات بين هذه الخطوات هي ما يقيسه امتثال اتفاقية مستوى الخدمة.",
bottlenecks: "الاختناقات",
whatNeedsAttention: "ما يحتاج إلى الاهتمام",
journeyCount_zero: "لا رحلات",
journeyCount_two: "رحلتان",
journeyCount_few: "{{count}} رحلات",
journeyCount_many: "{{count}} رحلةً",
},
screen: {
  aiSummaryButton: "كتابة ملخص بالذكاء الاصطناعي",
  emptyStartInspection: "بدء فحص",
  emptyAddAsset: "إضافة أصل",
scopeAllMultiTeam: "عمل الجميع — الأفضل لمقارنة الفرق جنبًا إلى جنب.",
scopeAllSingleTeam: "كل العمل في حسابك.",
scopePersonalMultiTeam: "عملك فقط. قم بالتبديل إلى الكل لرؤية الفريق بأكمله.",
scopePersonalSingleTeam: "عملك فقط.",
scopeTeamMultiTeam: "يتم تضمين {{team}} فقط. قم بتبديل النطاق إلى الكل لمقارنة الفرق جنبًا إلى جنب.",
scopeTeamSingleTeam: "يتم تضمين {{team}} فقط.",
greetingLate: "تعمل حتى وقت متأخر",
greetingMorning: "صباح الخير",
greetingAfternoon: "مساء الخير",
greetingEvening: "مساء الخير",
greetingNoPriorities: "لا توجد أولويات اليوم. الاتجاهات أدناه مع تراكم البيانات.",
greetingDanger_one: "مشكلة واحدة تحتاج إلى اهتمام اليوم — العنصر الأعلى شديد الخطورة.",
greetingDanger_other: "{{count}} مشكلة تحتاج إلى اهتمام اليوم — العنصر الأعلى شديد الخطورة.",
greetingTechnician_one: "لديك {{count}} مهمة قادمة. ابدأ بالبطاقة العلوية.",
greetingTechnician_other: "لديك {{count}} مهمة قادمة. ابدأ بالبطاقة العلوية.",
greetingExecutive_one: "إشارة واحدة تستحق النظر — مرتبة حسب التعرض المالي.",
greetingExecutive_other: "{{count}} إشارة تستحق النظر — مرتبة حسب التعرض المالي.",
greetingTeam_one: "أولوية واحدة للفريق اليوم.",
greetingTeam_other: "{{count}} أولوية للفريق اليوم.",
loadingTitle: "جارٍ تحميل الرؤى",
emptyGetsUsefulTitle: "تصبح الرؤى مفيدة مع الاستخدام",
emptyGetsUsefulDescription: "أضف أصلًا أو ابدأ فحصًا. ستعرض الرؤى بعدها ما يحتاج إلى اهتمام وما يتأخر.",
partialDataCaption: "تستخدم هذه المخططات السجلات المحملة. قد تكون إجماليات المحفظة غير مكتملة.",
partialDataCaptionConditionWhole: "تشمل الحالة ومستوى المخاطر والأصول المعرضة للخطر والأصول خارج الخدمة جميع الأصول. تستخدم الأرقام والمخططات الأخرى السجلات المحملة وقد تكون غير مكتملة.",
partialDataCaptionConditionBandsWhole: "تشمل الحالة ومستوى المخاطر والأصول المعرضة للخطر والأصول خارج الخدمة ونطاقات الحالة والأصول في حالة جيدة جميع الأصول. تستخدم الأرقام والمخططات الأخرى السجلات المحملة وقد تكون غير مكتملة.",
refreshErrorTitle: "تعذّر تحديث بعض بيانات الرؤى",
refreshErrorDescription: "تستخدم المخططات أدناه سجلات مخزنة مؤقتًا وقد تكون غير كاملة. حاول مرة أخرى عند توفر الاتصال.",
roleTechnician: "تقني",
roleManager: "مدير",
roleExecutive: "التنفيذي",
switchToRoleView: "قم بالتبديل إلى طريقة العرض {{role}}",
resetToAutoLabel: "إعادة التعيين إلى العرض المكتشف تلقائيًا",
resetToAutoText: "إعادة الضبط إلى تلقائي",
showingLabel: "يُعرض",
clearSiteFilter: "مسح مرشح الموقع",
allSites: "جميع المواقع",
unassignedSite: "بلا موقع",
selectedSiteFallback: "الموقع المحدد",
standardsEyebrow: "المعايير",
operationalKpisTitle: "مؤشرات الأداء الرئيسية التشغيلية",
subtitleNeedAttention_one: "واحد يحتاج إلى اهتمام · {{onTrack}} على الهدف",
subtitleNeedAttention_other: "{{count}} يحتاج إلى اهتمام · {{onTrack}} على الهدف",
subtitleAllOnTarget_zero: "جميع مؤشرات الأداء الرئيسية الـ{{count}} على الهدف",
subtitleAllOnTarget_one: "مؤشر الأداء الرئيسي الوحيد على الهدف",
subtitleAllOnTarget_two: "مؤشرا الأداء الرئيسيان على الهدف",
subtitleAllOnTarget_few: "جميع مؤشرات الأداء الرئيسية الـ{{count}} على الهدف",
subtitleAllOnTarget_many: "جميع مؤشرات الأداء الرئيسية الـ{{count}} على الهدف",
subtitleAllOnTarget_other: "جميع مؤشرات الأداء الرئيسية الـ{{count}} على الهدف",
asOfSuffix: "اعتبارًا من {{time}}",
kpiAllClearAccessibilityLabel_zero: "جميع مؤشرات الأداء الرئيسية الـ{{count}} على الهدف. عرض الكل.",
kpiAllClearAccessibilityLabel_one: "مؤشر الأداء الرئيسي الوحيد على الهدف. عرض الكل.",
kpiAllClearAccessibilityLabel_two: "مؤشرا الأداء الرئيسيان على الهدف. عرض الكل.",
kpiAllClearAccessibilityLabel_few: "جميع مؤشرات الأداء الرئيسية الـ{{count}} على الهدف. عرض الكل.",
kpiAllClearAccessibilityLabel_many: "جميع مؤشرات الأداء الرئيسية الـ{{count}} على الهدف. عرض الكل.",
kpiAllClearAccessibilityLabel_other: "جميع مؤشرات الأداء الرئيسية الـ{{count}} على الهدف. عرض الكل.",
kpiAllClearText_zero: "جميع مؤشرات الأداء الرئيسية الـ{{count}} على الهدف",
kpiAllClearText_one: "مؤشر الأداء الرئيسي الوحيد على الهدف",
kpiAllClearText_two: "مؤشرا الأداء الرئيسيان على الهدف",
kpiAllClearText_few: "جميع مؤشرات الأداء الرئيسية الـ{{count}} على الهدف",
kpiAllClearText_many: "جميع مؤشرات الأداء الرئيسية الـ{{count}} على الهدف",
kpiAllClearText_other: "جميع مؤشرات الأداء الرئيسية الـ{{count}} على الهدف",
showAllLabel: "إظهار الكل",
hideOnTargetKpis: "إخفاء مؤشرات الأداء المحققة للهدف",
showOnTargetKpis_one: "إظهار مؤشر أداء واحد على الهدف",
showOnTargetKpis_other: "إظهار {{count}} مؤشر أداء على الهدف",
conditionEyebrow: "الحالة",
conditionTitle: "ما هي الأصول التي تتدهور؟",
conditionSubtitle: "مشتق من عمليات الفحص والإصلاح وتاريخ الصيانة. اضغط على أحد الأصول للحصول على الأدلة الكاملة.",
maintenanceEyebrow: "الصيانة",
maintenanceTitle: "أين تتأخر الصيانة؟",
maintenanceSubtitle: "العمل المتخطّى قُرّر عمدًا، أما العمل الفائت فلا. ويُحسب كلٌّ منهما على حدة.",
sitesEyebrow: "المواقع",
sitesTitle: "ما هو الموقع الذي يحتاج إلى الاهتمام؟",
sitesSubtitle: "الصحة حسب الموقع، الأسوأ أولاً. انقر على أحد المواقع لتركيز لوحة المعلومات بأكملها عليه.",
focusOnSiteLabel: "ركز على {{name}}. الصحة {{score}} من 100.",
healthDetail: "الصحة {{score}}/100 · {{atRisk}} من {{total}} في خطر",
profileEyebrow: "اكتمال ملفات الأصول",
profileTitle: "أصول تنقص ملفاتها تفاصيل",
profileSubtitle: "سجلات الأصول هذه تفتقد الحقول المستخدمة في قوائم المراجعة وحسابات المخاطر والتوصيات.",
profileRowLabel: "لدى {{needsData}} من أصل {{total}} من الأصول ملفات غير مكتملة. افتح القائمة.",
profileRowTitle: "{{needsData}} من {{total}} من ملفات تعريف الأصول غير مكتملة",
profileWeak_one: "أصل واحد لديه تفاصيل منظمة قليلة جدًا. افتح القائمة لملء الفجوات.",
profileWeak_other: "{{count}} أصل لديها تفاصيل منظمة قليلة جدًا. افتح القائمة لملء الفجوات.",
profileOpenList: "افتح القائمة لمراجعة الحقول الناقصة وملئها.",
forecastEyebrow: "التوقعات",
forecastTitle: "ما هو القادم",
forecastSubtitle: "متوقَّع بناءً على انتهاء صلاحية الشهادات والجداول ووتيرة الإكمال — تصرّف قبل حدوث التأخير.",
todayEyebrow: "اليوم",
topPrioritiesTitle: "أهم الأولويات",
subtitleTechnician: "أوامر العمل التالية، مرتبة حسب درجة الاستعجال.",
subtitleManager: "أهم 5 أولويات مرتبة ضمن نطاقك، مع التبرير والإجراء الموصى به.",
visibleOfTotal: "{{visible}} من {{total}}",
viewDetailsLabel: "عرض التفاصيل",
workloadLabel: "عبء العمل",
reportingInsightLabel: "رؤية التقارير",
clearedTitle: "لا شيء مطلوب منك.",
clearedBody: "لا توجد أولويات في الوقت الحالي - سنعرض أولويات جديدة مع ورود البيانات.",
riskEyebrow: "المخاطر",
riskTitle: "أين تتركز المخاطر؟",
riskSubtitle: "التعرض للمخاطر مرتبًا عبر المحفظة، مقسَّمًا حسب الأهمية الحرجة ونمط العطل.",
rankedCount_zero: "{{count}} مصنَّف",
rankedCount_one: "{{count}} مصنَّف",
rankedCount_two: "{{count}} مصنَّف",
rankedCount_few: "{{count}} مصنَّف",
rankedCount_many: "{{count}} مصنَّف",
rankedCount_other: "{{count}} مصنَّف",
topExposuresEyebrow: "أعلى حالات التعرض",
topExposuresTitle: "ما هي الأصول التي تحمل أكبر قدر من التعرض؟",
nextAssetCaption: " التالي: {{name}} (الصحة {{score}}/100).",
riskHeatmapEyebrow: "خريطة الحرارة للمخاطر",
riskHeatmapTitle: "درجة الأهمية × نوع الأصل",
riskHeatmapCaption: "الخلايا الداكنة = متوسط أعلى لدرجة المخاطرة.",
riskByCriticalityEyebrow: "المخاطر حسب الأهمية",
riskByCriticalityTitle: "كيف يتم توزيع المخاطر حسب مستوى الأهمية؟",
riskByCriticalityCaption_one: "أصل واحد معرض للخطر · درجة المخاطرة 50/100 أو أعلى. الأصول التي تقل عن هذا الحد قد لا يزال لديها عمل متأخر.",
riskByCriticalityCaption_other: "{{count}} أصل معرض للخطر · درجة المخاطرة 50/100 أو أعلى. الأصول التي تقل عن هذا الحد قد لا يزال لديها عمل متأخر.",
topFailuresEyebrow: "أعلى فئات الفشل",
topFailuresTitle: "ما الذي يفشل في أغلب الأحيان؟",
topFailuresCaption_one: "{{label}} في الصدارة بعنصر واحد مُعلَّم؛ تحقق من السبب الجذري.",
topFailuresCaption_other: "{{label}} في الصدارة بـ {{count}} عنصر مُعلَّم؛ تحقق من السبب الجذري.",
fewerAnalytics: "تحليلات أقل",
moreAnalytics: "المزيد من التحليلات",
flowEyebrow: "التدفق",
flowTitle: "كيف يتدفق العمل؟",
flowSubtitle: "شكل الأعمال المتراكمة وجودة الفحص خلال آخر 28 يومًا.",
backlogEyebrow: "تركيبة الأعمال المتراكمة",
backlogTitle: "هل يتقلص حجم الأعمال المتراكمة أم يتزايد؟",
backlogCaption: "اليوم: {{overdue}} متأخرة · {{dueSoon}} مستحقة قريبًا · {{upcoming}} قادمة.",
legendOverdue: "متأخر",
legendDueIn7d: "مستحق خلال 7 أيام",
legendUpcoming: "القادم",
passRateEyebrow: "معدل نجاح التفتيش",
passRateTitle: "هل تنجح عمليات التفتيش أم تفشل؟",
passRateCaption: "حاليًا {{current}}% (مقابل {{prev}}% منذ 28 يومًا — {{arrow}} {{delta}} نقطة).",
passRateEmpty: "قم بإجراء المزيد من عمليات الفحص لملء الاتجاه.",
noScheduledTitle: "لا توجد عناصر مجدولة حتى الآن.",
noScheduledDescription: "بمجرد توفر أوامر عمل وعمليات فحص مؤرَّخة، ستظهر اتجاهات عبء العمل هنا.",
teamsEyebrow: "الفرق والشركاء",
teamsTitle: "كيف يكون أداء الفرق والمقاولين؟",
teamsSubtitle: "تعتمد الترتيبات على نطاقك الحالي ({{scope}}). قارن الفرق عندما يكون النطاق هو الكل.",
compareTeamsTitle: "قارن بين الفرق جنبًا إلى جنب",
compareTeamsBody: "أنت تشاهد الآن {{scope}}. قم بالتبديل إلى الكل لرؤية عبء العمل والإنتاجية مرتبة عبر كل فريق.",
switchToAll: "التبديل إلى الكل",
switchScopeAllLabel: "قم بتبديل النطاق إلى الكل لمقارنة الفرق",
teamWorkloadEyebrow: "عبء عمل الفريق",
teamWorkloadTitle: "ما الفرق التي لديها أكبر قدر من العمل المفتوح؟",
teamThroughputEyebrow: "إنتاجية الفريق",
teamThroughputTitle: "من أغلق أكبر قدر من العمل خلال 28 يومًا؟",
cycleTimesShown: "تظهر أوقات الدورة حيث يكون للمهام المكتملة تاريخا بدء وانتهاء.",
completedCountsCaption: "أعداد العمل المكتمل خلال آخر 28 يومًا في نطاقك الحالي.",
openLabel_zero: "{{count}} مفتوح",
openLabel_one: "{{count}} مفتوح",
openLabel_two: "{{count}} مفتوح",
openLabel_few: "{{count}} مفتوح",
openLabel_many: "{{count}} مفتوح",
openLabel_other: "{{count}} مفتوح",
overdueUnassigned: "{{overdue}} متأخرة · {{unassigned}} غير معين",
unassignedOnly_zero: "{{count}} غير مُسنَد",
unassignedOnly_one: "{{count}} غير مُسنَد",
unassignedOnly_two: "{{count}} غير مُسنَد",
unassignedOnly_few: "{{count}} غير مُسنَد",
unassignedOnly_many: "{{count}} غير مُسنَد",
unassignedOnly_other: "{{count}} غير مُسنَد",
doneLabel_zero: "{{count}} منجز",
doneLabel_one: "{{count}} منجز",
doneLabel_two: "{{count}} منجز",
doneLabel_few: "{{count}} منجز",
doneLabel_many: "{{count}} منجز",
doneLabel_other: "{{count}} منجز",
avgCycleDays: "متوسط الدورة {{days}} يوم",
stillOpen_zero: "{{count}} لا يزال مفتوحًا",
stillOpen_one: "{{count}} لا يزال مفتوحًا",
stillOpen_two: "{{count}} لا يزال مفتوحًا",
stillOpen_few: "{{count}} لا يزال مفتوحًا",
stillOpen_many: "{{count}} لا يزال مفتوحًا",
stillOpen_other: "{{count}} لا يزال مفتوحًا",
contractorPerformanceEyebrow: "أداء المقاول",
contractorPerformanceTitle: "كيف يقارن أداء المقاولين بعضهم ببعض؟",
overdueOnly_zero: "{{count}} متأخرة",
overdueOnly_one: "{{count}} متأخرة",
overdueOnly_two: "{{count}} متأخرة",
overdueOnly_few: "{{count}} متأخرة",
overdueOnly_many: "{{count}} متأخرة",
overdueOnly_other: "{{count}} متأخرة",
doneWindow_zero: "{{count}} منجز (28 يومًا)",
doneWindow_one: "{{count}} منجز (28 يومًا)",
doneWindow_two: "{{count}} منجز (28 يومًا)",
doneWindow_few: "{{count}} منجز (28 يومًا)",
doneWindow_many: "{{count}} منجز (28 يومًا)",
doneWindow_other: "{{count}} منجز (28 يومًا)",
sentBack_zero: "{{count}} أُعيد",
sentBack_one: "{{count}} أُعيد",
sentBack_two: "{{count}} أُعيد",
sentBack_few: "{{count}} أُعيد",
sentBack_many: "{{count}} أُعيد",
sentBack_other: "{{count}} أُعيد",
avgCycle: "متوسط {{days}} يوم",
toAnswer: "{{hours}} ساعة للرد",
declinedOnly_zero: "{{count}} مرفوض",
declinedOnly_one: "{{count}} مرفوض",
declinedOnly_two: "{{count}} مرفوض",
declinedOnly_few: "{{count}} مرفوض",
declinedOnly_many: "{{count}} مرفوض",
declinedOnly_other: "{{count}} مرفوض",
techQualityEyebrow: "جودة فني",
techQualityTitle: "من هم الفنيون الذين يحتاجون إلى التدريب؟",
techQualityCaption_one: "تجمع النتيجة بين الإكمال في الوقت المحدد مطروحًا منه إعادة الفتح (0–100). الوسيط {{median}}/100 عبر فني واحد.",
techQualityCaption_other: "تجمع النتيجة بين الإكمال في الوقت المحدد مطروحًا منه إعادة الفتح (0–100). الوسيط {{median}}/100 عبر {{count}} فني.",
technicianFallback: "تقني",
needsCoaching: "يحتاج إلى التدريب",
starPerformer: "الأداء المتميز",
onTrack: "على المسار الصحيح",
slippageEyebrow: "التأخر",
slippageTitle: "ما الذي يتأخر؟",
slippageSubtitle: "تغطية الفحص وهفوات الامتثال والفجوات في إيقاع الفحص الخاص بك.",
coverageGapsEyebrow: "فجوات التغطية",
coverageGapsTitle: "ما هي الأصول التي تحتاج إلى فحص الآن؟",
coverageGapsCaptionKnown: "العنصر العلوي: {{label}} ({{days}} يوم منذ آخر فحص). البنود مرتبة حسب الأيام × التأثير التشغيلي.",
coverageGapsCaptionNever: "العنصر العلوي: {{label}} (لم يتم فحصه مطلقًا). البنود مرتبة حسب الأيام × التأثير التشغيلي.",
neverLabel: "أبدًا",
complianceExpirationsEyebrow: "انتهاء صلاحية الامتثال",
complianceExpirationsTitle: "ما الذي تنتهي صلاحيته خلال الـ 90 يومًا القادمة؟",
complianceExpirationsCaption: "{{expired}} منتهية الصلاحية بالفعل، و{{expiringSoon}} تنتهي صلاحيتها خلال 14 يومًا.",
overdueDays: "متأخر {{days}} يوم",
daysLeft: "متبقٍ {{days}} يوم",
inspectionDensityEyebrow: "كثافة الفحص",
inspectionDensityTitle: "أين توجد فجوات الإيقاع؟",
inspectionDensityCaption_zero: "{{count}} تفتيش في آخر 6 أشهر تقريبًا. الفترات الفارغة تشير إلى فجوات في التغطية.",
inspectionDensityCaption_one: "تفتيش واحد في آخر 6 أشهر تقريبًا. الفترات الفارغة تشير إلى فجوات في التغطية.",
inspectionDensityCaption_two: "تفتيشان في آخر 6 أشهر تقريبًا. الفترات الفارغة تشير إلى فجوات في التغطية.",
inspectionDensityCaption_few: "{{count}} تفتيشات في آخر 6 أشهر تقريبًا. الفترات الفارغة تشير إلى فجوات في التغطية.",
inspectionDensityCaption_many: "{{count}} تفتيشًا في آخر 6 أشهر تقريبًا. الفترات الفارغة تشير إلى فجوات في التغطية.",
inspectionDensityCaption_other: "{{count}} تفتيش في آخر 6 أشهر تقريبًا. الفترات الفارغة تشير إلى فجوات في التغطية.",
activityEyebrow: "النشاط",
activityTitle: "ماذا حدث للتو؟",
activitySubtitle: "أحدث عمليات التفتيش وتحديثات أوامر العمل عبر نطاقك.",
whenToday: "اليوم",
whenYesterday: "أمس",
whenDaysAgo: "منذ {{days}} يوم",
severityFooterText: "تظهر الخطورة كتأثير تشغيلي (منخفض ← حرج)، وليس كقيم بالدولار. لا يقوم AssetWRX بإدارة الأرباح والخسائر — فبيانات التكلفة تنتمي إلى نظام تخطيط موارد المؤسسات (ERP) الخاص بك. عندما تقوم بتوصيل واحد، يمكن إضافة أرقام $ هنا.",
askTitle: "اسأل AssetWRX",
askPlaceholderExecutive: "على سبيل المثال. ما هي المواقع الأكثر تكلفة في الربع الأخير؟",
askPlaceholderTechnician: "على سبيل المثال. ما هي أوامر العمل الخاصة بي اليوم؟",
askPlaceholderManager: "على سبيل المثال. ما هي الأصول المقرر فحصها؟",
askButton: "اسأل",
pageSubtitle: "تعرف على الأماكن التي يتراكم فيها العمل، والأصول المعرضة للخطر، والأشخاص المثقلين بالأعباء.",
greetingDanger_zero: "لا مشكلات تحتاج إلى اهتمام اليوم.",
greetingDanger_two: "مشكلتان تحتاجان إلى اهتمام اليوم — العنصر الأعلى شديد الخطورة.",
greetingDanger_few: "{{count}} مشكلات تحتاج إلى اهتمام اليوم — العنصر الأعلى شديد الخطورة.",
greetingDanger_many: "{{count}} مشكلة تحتاج إلى اهتمام اليوم — العنصر الأعلى شديد الخطورة.",
greetingTechnician_zero: "ليس لديك أي مهام قادمة. ابدأ بالبطاقة العلوية.",
greetingTechnician_two: "لديك مهمتان قادمتان. ابدأ بالبطاقة العلوية.",
greetingTechnician_few: "لديك {{count}} مهام قادمة. ابدأ بالبطاقة العلوية.",
greetingTechnician_many: "لديك {{count}} مهمة قادمة. ابدأ بالبطاقة العلوية.",
greetingExecutive_zero: "لا إشارات تستحق النظر.",
greetingExecutive_two: "إشارتان تستحقان النظر — مرتبتان حسب التعرض المالي.",
greetingExecutive_few: "{{count}} إشارات تستحق النظر — مرتبة حسب التعرض المالي.",
greetingExecutive_many: "{{count}} إشارة تستحق النظر — مرتبة حسب التعرض المالي.",
greetingTeam_zero: "لا أولويات للفريق اليوم.",
greetingTeam_two: "أولويتان للفريق اليوم.",
greetingTeam_few: "{{count}} أولويات للفريق اليوم.",
greetingTeam_many: "{{count}} أولوية للفريق اليوم.",
subtitleNeedAttention_zero: "لا شيء يحتاج إلى اهتمام · {{onTrack}} على الهدف",
subtitleNeedAttention_two: "اثنان يحتاجان إلى اهتمام · {{onTrack}} على الهدف",
subtitleNeedAttention_few: "{{count}} تحتاج إلى اهتمام · {{onTrack}} على الهدف",
subtitleNeedAttention_many: "{{count}} يحتاج إلى اهتمام · {{onTrack}} على الهدف",
showOnTargetKpis_zero: "لا مؤشرات أداء على الهدف",
showOnTargetKpis_two: "إظهار مؤشري أداء على الهدف",
showOnTargetKpis_few: "إظهار {{count}} مؤشرات أداء على الهدف",
showOnTargetKpis_many: "إظهار {{count}} مؤشر أداء على الهدف",
profileWeak_zero: "لا أصول ذات تفاصيل منظمة قليلة.",
profileWeak_two: "أصلان لديهما تفاصيل منظمة قليلة جدًا. افتح القائمة لملء الفجوات.",
profileWeak_few: "{{count}} أصول لديها تفاصيل منظمة قليلة جدًا. افتح القائمة لملء الفجوات.",
profileWeak_many: "{{count}} أصلًا لديها تفاصيل منظمة قليلة جدًا. افتح القائمة لملء الفجوات.",
riskByCriticalityCaption_zero: "لا أصول معرضة للخطر · درجة المخاطرة 50/100 أو أعلى. الأصول التي تقل عن هذا الحد قد لا يزال لديها عمل متأخر.",
riskByCriticalityCaption_two: "أصلان معرضان للخطر · درجة المخاطرة 50/100 أو أعلى. الأصول التي تقل عن هذا الحد قد لا يزال لديها عمل متأخر.",
riskByCriticalityCaption_few: "{{count}} أصول معرضة للخطر · درجة المخاطرة 50/100 أو أعلى. الأصول التي تقل عن هذا الحد قد لا يزال لديها عمل متأخر.",
riskByCriticalityCaption_many: "{{count}} أصلًا معرضًا للخطر · درجة المخاطرة 50/100 أو أعلى. الأصول التي تقل عن هذا الحد قد لا يزال لديها عمل متأخر.",
topFailuresCaption_zero: "{{label}} في الصدارة بلا عناصر مُعلَّمة؛ تحقق من السبب الجذري.",
topFailuresCaption_two: "{{label}} في الصدارة بعنصرين مُعلَّمين؛ تحقق من السبب الجذري.",
topFailuresCaption_few: "{{label}} في الصدارة بـ {{count}} عناصر مُعلَّمة؛ تحقق من السبب الجذري.",
topFailuresCaption_many: "{{label}} في الصدارة بـ {{count}} عنصرًا مُعلَّمًا؛ تحقق من السبب الجذري.",
techQualityCaption_zero: "تجمع النتيجة بين الإكمال في الوقت المحدد مطروحًا منه إعادة الفتح (0–100). الوسيط {{median}}/100 بلا فنيين.",
techQualityCaption_two: "تجمع النتيجة بين الإكمال في الوقت المحدد مطروحًا منه إعادة الفتح (0–100). الوسيط {{median}}/100 عبر فنيَّين.",
techQualityCaption_few: "تجمع النتيجة بين الإكمال في الوقت المحدد مطروحًا منه إعادة الفتح (0–100). الوسيط {{median}}/100 عبر {{count}} فنيين.",
techQualityCaption_many: "تجمع النتيجة بين الإكمال في الوقت المحدد مطروحًا منه إعادة الفتح (0–100). الوسيط {{median}}/100 عبر {{count}} فنيًا.",
},
},
repairsApproved_zero: "لا إصلاحات معتمدة",
repairsApproved_two: "إصلاحان معتمدان",
repairsApproved_few: "{{count}} إصلاحات معتمدة",
repairsApproved_many: "{{count}} إصلاحًا معتمدًا",
title: "النشاط",
viewFeed: "عرض نشاط الفريق",
analyticsTitle: "الرؤى",
recommendations: {
whyPrefix: "السبب:",
failureTitle: "{{asset}} — الصحة {{score}}/100",
impactRisk: "المخاطر",
actionOpenAsset: "فتح الأصل",
actionScheduleAction: "جدولة إجراء",
actionAssignTechnician: "تعيين فني",
thinHistory: "سجل هذا الأصل محدود — سجّل فحصًا لتصبح الدرجة أدق.",
overdueTitle_zero: "لا مهام متأخرة ضمن نطاقك",
overdueTitle_one: "مهمة واحدة متأخرة ضمن نطاقك",
overdueTitle_two: "مهمتان متأخرتان ضمن نطاقك",
overdueTitle_few: "{{count}} مهام متأخرة ضمن نطاقك",
overdueTitle_many: "{{count}} مهمةً متأخرةً ضمن نطاقك",
overdueTitle_other: "{{count}} مهمة متأخرة ضمن نطاقك",
overdueWhy: "السبب: مرّت تواريخ الاستحقاق دون إكمال — والأعمال المتراكمة تتزايد.",
impactOldest: "الأقدم",
oldestValue_zero: "متأخرة {{count}} ي",
oldestValue_one: "متأخرة {{count}} ي",
oldestValue_two: "متأخرة {{count}} ي",
oldestValue_few: "متأخرة {{count}} ي",
oldestValue_many: "متأخرة {{count}} ي",
oldestValue_other: "متأخرة {{count}} ي",
actionTriageBacklog: "فرز الأعمال المتراكمة",
complianceTitle_zero: "لا بنود امتثال تنتهي صلاحيتها خلال 30 يومًا",
complianceTitle_one: "بند امتثال واحد تنتهي صلاحيته خلال 30 يومًا",
complianceTitle_two: "بندا امتثال تنتهي صلاحيتهما خلال 30 يومًا",
complianceTitle_few: "{{count}} بنود امتثال تنتهي صلاحيتها خلال 30 يومًا",
complianceTitle_many: "{{count}} بندًا للامتثال تنتهي صلاحيتها خلال 30 يومًا",
complianceTitle_other: "{{count}} بند امتثال تنتهي صلاحيتها خلال 30 يومًا",
complianceWhy: "السبب: تنقضي صلاحية الشهادات والفحوصات إذا لم يُتخذ إجراء.",
impactAtRisk: "معرّض للخطر",
assetsCount_zero: "لا أصول",
assetsCount_one: "أصل واحد",
assetsCount_two: "أصلان",
assetsCount_few: "{{count}} أصول",
assetsCount_many: "{{count}} أصلًا",
assetsCount_other: "{{count}} أصل",
actionOpenCompliance: "فتح الامتثال",
trainingTitle_zero: "لا فنيين لديهم إعادات فتح متكررة",
trainingTitle_one: "فني واحد لديه إعادات فتح متكررة",
trainingTitle_two: "فنيان لديهما إعادات فتح متكررة",
trainingTitle_few: "{{count}} فنيين لديهم إعادات فتح متكررة",
trainingTitle_many: "{{count}} فنيًا لديهم إعادات فتح متكررة",
trainingTitle_other: "{{count}} فني لديهم إعادات فتح متكررة",
trainingWhy: "السبب: أُعيد فتح أعمال على فئة الأصول نفسها عدة مرات خلال 90 يومًا — على الأرجح فجوة في التدريب.",
impactRecurringRework: "إعادة عمل متكررة",
reopensCount_zero: "لا إعادات فتح",
reopensCount_one: "إعادة فتح واحدة",
reopensCount_two: "إعادتا فتح",
reopensCount_few: "{{count}} إعادات فتح",
reopensCount_many: "{{count}} إعادةَ فتح",
reopensCount_other: "{{count}} إعادة فتح",
actionViewContacts: "عرض جهات الاتصال",
inspectionDueTitle_zero: "لا أصول تحتاج إلى فحص",
inspectionDueTitle_one: "أصل واحد يحتاج إلى فحص",
inspectionDueTitle_two: "أصلان يحتاجان إلى فحص",
inspectionDueTitle_few: "{{count}} أصول تحتاج إلى فحص",
inspectionDueTitle_many: "{{count}} أصلًا تحتاج إلى فحص",
inspectionDueTitle_other: "{{count}} أصل تحتاج إلى فحص",
inspectionDueWhy: "السبب: لم يُكمَل أي فحص خلال آخر 90 يومًا.",
impactCoverageGap: "فجوة في التغطية",
actionScheduleInspections: "جدولة الفحوصات",
approvalsInspections_zero: "لا فحوصات بانتظار الموافقة",
approvalsInspections_one: "فحص واحد بانتظار الموافقة",
approvalsInspections_two: "فحصان بانتظار الموافقة",
approvalsInspections_few: "{{count}} فحوصات بانتظار الموافقة",
approvalsInspections_many: "{{count}} فحصًا بانتظار الموافقة",
approvalsInspections_other: "{{count}} فحص بانتظار الموافقة",
approvalsJobs_zero: "لا مهام بانتظار التحقق",
approvalsJobs_one: "مهمة واحدة بانتظار التحقق",
approvalsJobs_two: "مهمتان بانتظار التحقق",
approvalsJobs_few: "{{count}} مهام بانتظار التحقق",
approvalsJobs_many: "{{count}} مهمةً بانتظار التحقق",
approvalsJobs_other: "{{count}} مهمة بانتظار التحقق",
approvalsTitle_zero: "لا قرارات بانتظارك",
approvalsTitle_one: "قرار واحد بانتظارك",
approvalsTitle_two: "قراران بانتظارك",
approvalsTitle_few: "{{count}} قرارات بانتظارك",
approvalsTitle_many: "{{count}} قرارًا بانتظارك",
approvalsTitle_other: "{{count}} قرار بانتظارك",
approvalsWhyOne: "السبب: {{part}}. يبقى العمل مفتوحًا حتى يعتمده أحد.",
approvalsWhyBoth: "السبب: {{first}} و{{second}}. يبقى العمل مفتوحًا حتى يعتمده أحد.",
impactWaiting: "قيد الانتظار",
actionReviewApprove: "المراجعة والموافقة",
jobFallback: "مهمة",
nextJobDue: "السبب: مستحقة في {{date}}.",
nextJobAssigned: "السبب: مُسندة إليك.",
impactUrgency: "درجة الاستعجال",
actionOpenJob: "فتح المهمة",
},
insightQuality: {
confidenceHigh: "ثقة عالية",
confidenceMedium: "ثقة متوسطة",
confidenceLow: "ثقة منخفضة",
notEnoughHistory: "{{label}} · لا يوجد سجل حديث كافٍ",
basedOnOne: "{{label}} · بناءً على {{part}}",
basedOnBoth: "{{label}} · بناءً على {{first}} و{{second}}",
inspections_zero: "{{count}} فحص",
inspections_one: "فحص واحد",
inspections_two: "فحصين",
inspections_few: "{{count}} فحوصات",
inspections_many: "{{count}} فحصًا",
inspections_other: "{{count}} فحص",
jobs_zero: "{{count}} مهمة",
jobs_one: "مهمة واحدة",
jobs_two: "مهمتين",
jobs_few: "{{count}} مهام",
jobs_many: "{{count}} مهمةً",
jobs_other: "{{count}} مهمة",
noInspectionsInScope: "لا توجد فحوصات ضمن النطاق",
limitedJobHistory: "سجل المهام محدود",
noCompletedInspections: "لا توجد فحوصات مكتملة",
noInspectionInDays_zero: "لا يوجد فحص منذ {{count}} يوم",
noInspectionInDays_one: "لا يوجد فحص منذ يوم واحد",
noInspectionInDays_two: "لا يوجد فحص منذ يومين",
noInspectionInDays_few: "لا يوجد فحص منذ {{count}} أيام",
noInspectionInDays_many: "لا يوجد فحص منذ {{count}} يومًا",
noInspectionInDays_other: "لا يوجد فحص منذ {{count}} يوم",
noInspectionHistory: "لا يوجد سجل فحوصات",
assetMetadataIncomplete: "البيانات الوصفية للأصل غير مكتملة",
noRecentTimestamps: "لا توجد طوابع زمنية لنشاط حديث",
dataGapNoInspection_zero: "فجوة في البيانات: لا يوجد فحص منذ {{count}} يوم",
dataGapNoInspection_one: "فجوة في البيانات: لا يوجد فحص منذ يوم واحد",
dataGapNoInspection_two: "فجوة في البيانات: لا يوجد فحص منذ يومين",
dataGapNoInspection_few: "فجوة في البيانات: لا يوجد فحص منذ {{count}} أيام",
dataGapNoInspection_many: "فجوة في البيانات: لا يوجد فحص منذ {{count}} يومًا",
dataGapNoInspection_other: "فجوة في البيانات: لا يوجد فحص منذ {{count}} يوم",
dataGapLastActivity_zero: "فجوة في البيانات: آخر نشاط قبل {{count}} يوم",
dataGapLastActivity_one: "فجوة في البيانات: آخر نشاط قبل يوم واحد",
dataGapLastActivity_two: "فجوة في البيانات: آخر نشاط قبل يومين",
dataGapLastActivity_few: "فجوة في البيانات: آخر نشاط قبل {{count}} أيام",
dataGapLastActivity_many: "فجوة في البيانات: آخر نشاط قبل {{count}} يومًا",
dataGapLastActivity_other: "فجوة في البيانات: آخر نشاط قبل {{count}} يوم",
limitedData: "بيانات محدودة — تعامل معها كمؤشر عام فقط",
},
activityTimeline: {
inspectionCompleted: "اكتمل الفحص",
inspectionInProgress: "الفحص قيد التنفيذ",
itemsFlagged_zero: "لا عناصر مُعلَّمة",
itemsFlagged_one: "عنصر واحد مُعلَّم",
itemsFlagged_two: "عنصران مُعلَّمان",
itemsFlagged_few: "{{count}} عناصر مُعلَّمة",
itemsFlagged_many: "{{count}} عنصرًا مُعلَّمًا",
itemsFlagged_other: "{{count}} عنصر مُعلَّم",
allPassing: "جميع العناصر ناجحة",
jobUpdated: "حُدّثت المهمة",
},
portfolioNarrative: {
flat: "صحة المحفظة {{score}}/100 — ستظهر الاتجاهات مع تراكم البيانات.",
improved_zero: "محفظتك أفضل صحةً هذا الشهر — ارتفعت الصحة التشغيلية {{count}} نقطة إلى {{score}}/100{{driver}}.",
improved_one: "محفظتك أفضل صحةً هذا الشهر — ارتفعت الصحة التشغيلية نقطة واحدة إلى {{score}}/100{{driver}}.",
improved_two: "محفظتك أفضل صحةً هذا الشهر — ارتفعت الصحة التشغيلية نقطتين إلى {{score}}/100{{driver}}.",
improved_few: "محفظتك أفضل صحةً هذا الشهر — ارتفعت الصحة التشغيلية {{count}} نقاط إلى {{score}}/100{{driver}}.",
improved_many: "محفظتك أفضل صحةً هذا الشهر — ارتفعت الصحة التشغيلية {{count}} نقطةً إلى {{score}}/100{{driver}}.",
improved_other: "محفظتك أفضل صحةً هذا الشهر — ارتفعت الصحة التشغيلية {{count}} نقطة إلى {{score}}/100{{driver}}.",
improvedDriver_zero: "، دون أن يخرج أي أصل من فئة الأصول المعرّضة للخطر",
improvedDriver_one: "، إذ خرج أصل واحد من فئة الأصول المعرّضة للخطر",
improvedDriver_two: "، إذ خرج أصلان من فئة الأصول المعرّضة للخطر",
improvedDriver_few: "، إذ خرجت {{count}} أصول من فئة الأصول المعرّضة للخطر",
improvedDriver_many: "، إذ خرج {{count}} أصلًا من فئة الأصول المعرّضة للخطر",
improvedDriver_other: "، إذ خرج {{count}} أصل من فئة الأصول المعرّضة للخطر",
slipped_zero: "تراجعت صحة المحفظة {{count}} نقطة إلى {{score}}/100 هذا الشهر.",
slipped_one: "تراجعت صحة المحفظة نقطة واحدة إلى {{score}}/100 هذا الشهر.",
slipped_two: "تراجعت صحة المحفظة نقطتين إلى {{score}}/100 هذا الشهر.",
slipped_few: "تراجعت صحة المحفظة {{count}} نقاط إلى {{score}}/100 هذا الشهر.",
slipped_many: "تراجعت صحة المحفظة {{count}} نقطةً إلى {{score}}/100 هذا الشهر.",
slipped_other: "تراجعت صحة المحفظة {{count}} نقطة إلى {{score}}/100 هذا الشهر.",
steady: "بقيت صحة المحفظة مستقرة عند {{score}}/100 هذا الشهر.",
concern: " يستحق المتابعة: {{concern}}.",
},
partnersCaptions: {
teamEmpty: "أسند المهام إلى الفرق لمقارنة عبء العمل والإنتاجية.",
teamSingle: "{{team}}: {{open}} مفتوحة، و{{completed}} مكتملة خلال {{days}} ي.",
teamOverdue: "لدى {{worst}} أكثر الأعمال المتأخرة ({{overdue}})؛ ولدى {{leader}} أكبر قائمة أعمال مفتوحة ({{open}}).",
teamThroughput: "لدى {{leader}} أكبر قائمة أعمال مفتوحة؛ وأغلق {{top}} أكبر عدد خلال {{days}} ي ({{completed}}).",
teamLeader_zero: "لدى {{leader}} أكبر قائمة أعمال مفتوحة ({{count}} مهمة).",
teamLeader_one: "لدى {{leader}} أكبر قائمة أعمال مفتوحة (مهمة واحدة).",
teamLeader_two: "لدى {{leader}} أكبر قائمة أعمال مفتوحة (مهمتان).",
teamLeader_few: "لدى {{leader}} أكبر قائمة أعمال مفتوحة ({{count}} مهام).",
teamLeader_many: "لدى {{leader}} أكبر قائمة أعمال مفتوحة ({{count}} مهمةً).",
teamLeader_other: "لدى {{leader}} أكبر قائمة أعمال مفتوحة ({{count}} مهمة).",
contractorEmpty: "أسند المهام التي ينفذها مقاولون لترى أداءهم هنا.",
contractorOverdue_zero: "ليس لدى {{worst}} مهام متأخرة؛ ولدى {{leader}} أعلى عبء عمل نشط ({{open}} مفتوحة).",
contractorOverdue_one: "لدى {{worst}} مهمة واحدة متأخرة؛ ولدى {{leader}} أعلى عبء عمل نشط ({{open}} مفتوحة).",
contractorOverdue_two: "لدى {{worst}} مهمتان متأخرتان؛ ولدى {{leader}} أعلى عبء عمل نشط ({{open}} مفتوحة).",
contractorOverdue_few: "لدى {{worst}} {{count}} مهام متأخرة؛ ولدى {{leader}} أعلى عبء عمل نشط ({{open}} مفتوحة).",
contractorOverdue_many: "لدى {{worst}} {{count}} مهمةً متأخرةً؛ ولدى {{leader}} أعلى عبء عمل نشط ({{open}} مفتوحة).",
contractorOverdue_other: "لدى {{worst}} {{count}} مهمة متأخرة؛ ولدى {{leader}} أعلى عبء عمل نشط ({{open}} مفتوحة).",
contractorRework_zero: "لم تُعَد أي مهمة إلى {{name}} للتعديل؛ ويتصدر {{leader}} التعيينات المفتوحة ({{open}}).",
contractorRework_one: "أُعيدت مهمة واحدة إلى {{name}} للتعديل؛ ويتصدر {{leader}} التعيينات المفتوحة ({{open}}).",
contractorRework_two: "أُعيدت مهمتان إلى {{name}} للتعديل؛ ويتصدر {{leader}} التعيينات المفتوحة ({{open}}).",
contractorRework_few: "أُعيدت {{count}} مهام إلى {{name}} للتعديل؛ ويتصدر {{leader}} التعيينات المفتوحة ({{open}}).",
contractorRework_many: "أُعيدت {{count}} مهمةً إلى {{name}} للتعديل؛ ويتصدر {{leader}} التعيينات المفتوحة ({{open}}).",
contractorRework_other: "أُعيدت {{count}} مهمة إلى {{name}} للتعديل؛ ويتصدر {{leader}} التعيينات المفتوحة ({{open}}).",
contractorCompleted_zero: "لم يُكمل {{name}} أي مهمة خلال {{days}} ي؛ ولدى {{leader}} {{open}} مفتوحة.",
contractorCompleted_one: "أكمل {{name}} مهمة واحدة خلال {{days}} ي؛ ولدى {{leader}} {{open}} مفتوحة.",
contractorCompleted_two: "أكمل {{name}} مهمتين خلال {{days}} ي؛ ولدى {{leader}} {{open}} مفتوحة.",
contractorCompleted_few: "أكمل {{name}} {{count}} مهام خلال {{days}} ي؛ ولدى {{leader}} {{open}} مفتوحة.",
contractorCompleted_many: "أكمل {{name}} {{count}} مهمةً خلال {{days}} ي؛ ولدى {{leader}} {{open}} مفتوحة.",
contractorCompleted_other: "أكمل {{name}} {{count}} مهمة خلال {{days}} ي؛ ولدى {{leader}} {{open}} مفتوحة.",
contractorLeader: "لدى {{leader}} أعلى عبء عمل بين المقاولين ({{open}} مفتوحة).",
},
siteRisk: {
whyTwoDrivers: "الصحة التشغيلية {{score}}/100 — المخاطر ناتجة عن {{first}} و{{second}}.",
whyOneDriver: "الصحة التشغيلية {{score}}/100 — المخاطر ناتجة عن {{driver}}.",
whyExposure: "الصحة التشغيلية {{score}}/100 — التعرض التشغيلي {{risk}}/100.",
subLabelExposure: "التعرض التشغيلي {{risk}}/100",
},
rootCause: {
assetCount_zero: "{{count}} أصل",
assetCount_one: "أصل واحد",
assetCount_two: "أصلين",
assetCount_few: "{{count}} أصول",
assetCount_many: "{{count}} أصلًا",
assetCount_other: "{{count}} أصل",
dayCount_zero: "{{count}} يوم",
dayCount_one: "يوم واحد",
dayCount_two: "يومين",
dayCount_few: "{{count}} أيام",
dayCount_many: "{{count}} يومًا",
dayCount_other: "{{count}} يوم",
jobCount_zero: "{{count}} مهمة",
jobCount_one: "مهمة واحدة",
jobCount_two: "مهمتان",
jobCount_few: "{{count}} مهام",
jobCount_many: "{{count}} مهمةً",
jobCount_other: "{{count}} مهمة",
categoryJobs_zero: "{{count}} مهمة من فئة {{category}}",
categoryJobs_one: "مهمة واحدة من فئة {{category}}",
categoryJobs_two: "مهمتان من فئة {{category}}",
categoryJobs_few: "{{count}} مهام من فئة {{category}}",
categoryJobs_many: "{{count}} مهمةً من فئة {{category}}",
categoryJobs_other: "{{count}} مهمة من فئة {{category}}",
itemFailures_zero: "{{count}} حالة فشل في «{{label}}»",
itemFailures_one: "حالة فشل واحدة في «{{label}}»",
itemFailures_two: "حالتا فشل في «{{label}}»",
itemFailures_few: "{{count}} حالات فشل في «{{label}}»",
itemFailures_many: "{{count}} حالةَ فشل في «{{label}}»",
itemFailures_other: "{{count}} حالة فشل في «{{label}}»",
categoryIssues_zero: "{{count}} مشكلة من فئة {{category}}",
categoryIssues_one: "مشكلة واحدة من فئة {{category}}",
categoryIssues_two: "مشكلتان من فئة {{category}}",
categoryIssues_few: "{{count}} مشكلات من فئة {{category}}",
categoryIssues_many: "{{count}} مشكلةً من فئة {{category}}",
categoryIssues_other: "{{count}} مشكلة من فئة {{category}}",
jobReopens_zero: "{{count}} إعادة فتح للمهام",
jobReopens_one: "إعادة فتح واحدة لمهمة",
jobReopens_two: "إعادتا فتح للمهام",
jobReopens_few: "{{count}} إعادات فتح للمهام",
jobReopens_many: "{{count}} إعادةَ فتح للمهام",
jobReopens_other: "{{count}} إعادة فتح للمهام",
reopenCount_zero: "{{count}} إعادة فتح",
reopenCount_one: "إعادة فتح واحدة",
reopenCount_two: "إعادتا فتح",
reopenCount_few: "{{count}} إعادات فتح",
reopenCount_many: "{{count}} إعادةَ فتح",
reopenCount_other: "{{count}} إعادة فتح",
likelyDriver: "السبب المرجّح: {{driver}}",
titleJobCategory: "نمط متكرر: {{jobs}} عبر {{assets}} خلال {{days}}",
driverJobCategory: "تكرار فئة العمل {{category}} عبر أصول متشابهة.",
driverJobCategoryScope: "ربما لم يُعالَج المسبّب التشغيلي نفسه أو نطاق قائمة التحقق بما يكفي.",
counterJobCategory: "قد تتكرر الفئة نفسها في الصيانة المخططة لأسباب مشروعة — تحقّق من الجداول.",
actionJobCategory: "راجع نطاق أعمال {{category}} وطريقة الإصلاح، وافحص الأصول ذات الصلة.",
titleInspectionItem: "نمط متكرر: {{failures}} عبر {{assets}} خلال {{days}}{{site}}",
siteSame: " في الموقع نفسه",
siteMultiple: " عبر عدة مواقع",
driverInspectionItem: "فشل بند الفحص نفسه مرارًا ({{label}}).",
driverInspectionItemScope: "نطاق قائمة التحقق، أو الظروف البيئية، أو التحقق من الإصلاح في هذا البند.",
counterInspectionItem: "قد تؤدي حملات الفحص الموسمية أو التي تُجرى لمرة واحدة إلى تجمّع حالات الفشل مؤقتًا.",
actionInspectionItem: "راجع بند قائمة التحقق «{{label}}» وافحص الأصول ذات الصلة في الموقع.",
titleAssetRepeat: "نمط متكرر: {{asset}} يتعطل مجددًا بعد الإصلاح ({{jobs}} خلال {{days}})",
driverAssetRepeat: "تكرار فئة العطل نفسها بعد الإصلاح.",
driverAssetRepeatCause: "ربما لم تُحَلّ المشكلة في طريقة الإصلاح أو القطع أو العيب الجذري.",
counterAssetRepeat: "قد يكون العمل اللاحق تحققًا مخططًا له — تأكّد من الغرض من المهمة.",
actionAssetRepeat: "راجع طريقة الإصلاح وافحص الأصول ذات الصلة.",
latestRepair: "آخر إصلاح",
postRepairInspection: "فحص بعد الإصلاح فيه حالات فشل",
titleFailureType: "نمط متكرر: {{issues}} في أصول من نوع {{assetType}} ({{assets}}، {{days}})",
driverFailureType: "تجمّع أعطال فئة {{category}} في أصول من نوع {{assetType}}.",
counterFailureType: "قد يكون عدد الأصول من هذا النوع صغيرًا — تأكّد من أن العينة ممثِّلة.",
actionFailureType: "راجع معايير {{category}} للأصول من نوع {{assetType}} وبنود قائمة التحقق ذات الصلة.",
titleTechReopen: "نمط متكرر: {{reopens}} على صلة بـ{{name}} خلال {{days}}",
driverTechReopen_zero: "ارتباط {{name}} بإعادات فتح متكررة في {{count}} فئة.",
driverTechReopen_one: "ارتباط {{name}} بإعادات فتح متكررة في فئة واحدة.",
driverTechReopen_two: "ارتباط {{name}} بإعادات فتح متكررة في فئتين.",
driverTechReopen_few: "ارتباط {{name}} بإعادات فتح متكررة في {{count}} فئات.",
driverTechReopen_many: "ارتباط {{name}} بإعادات فتح متكررة في {{count}} فئةً.",
driverTechReopen_other: "ارتباط {{name}} بإعادات فتح متكررة في {{count}} فئة.",
driverTechReopenCause: "قد تحتاج معايير الإغلاق أو القطع أو جودة التسليم إلى مراجعة.",
counterTechReopen: "قد تعكس إعادات الفتح طلبات عودة من العملاء لا علاقة لها بمهارة الفني.",
actionTechReopen: "راجع المهام المُعاد فتحها مع {{name}} وتحقّق من معايير الإغلاق.",
titleVendorReopen: "نمط متكرر: {{reopens}} مع المقاول {{name}} خلال {{days}}",
driverVendor: "ارتباط المقاول {{name}} بإعادات فتح متكررة.",
counterVendor: "قد تتزامن ذروات عبء عمل المقاول مع إعادات الفتح دون وجود مشكلات في الجودة.",
actionVendor: "راجع أداء المقاول {{name}} ونطاق عمله.",
titlePart: "نمط متكرر: {{jobs}} بشأن «{{part}}» عبر {{assets}} خلال {{days}}",
driverPart: "ارتباط القطعة أو الفئة «{{part}}» بمهام متكررة.",
counterPart: "قد تتكرر القطعة نفسها عبر الأصول لأسباب مشروعة بسبب التخزين أو مجموعات الصيانة المخططة.",
actionPart: "راجع جودة «{{part}}» ومدى ملاءمتها ونطاق الصيانة المخططة لها.",
assetFallback: "أصل",
jobFallback: "مهمة",
contractorFallback: "مقاول",
checklistItemFallback: "بند قائمة التحقق",
uncategorised: "غير مصنَّف",
impactRecurrence: "التكرار",
impactRecurrenceValue_zero: "{{events}} خلال {{count}} يوم",
impactRecurrenceValue_one: "{{events}} خلال يوم واحد",
impactRecurrenceValue_two: "{{events}} خلال يومين",
impactRecurrenceValue_few: "{{events}} خلال {{count}} أيام",
impactRecurrenceValue_many: "{{events}} خلال {{count}} يومًا",
impactRecurrenceValue_other: "{{events}} خلال {{count}} يوم",
reviewPattern: "مراجعة النمط",
viewJobs: "عرض المهام",
},
actionPlans: {
reviewData: "مراجعة البيانات",
reviewDataDetail: "تأكّد من سجل الفحوصات والمهام قبل تخصيص الموارد.",
withinDays_zero: "اليوم",
withinDays_one: "خلال يوم واحد",
withinDays_two: "خلال يومين",
withinDays_few: "خلال {{count}} أيام",
withinDays_many: "خلال {{count}} يومًا",
withinDays_other: "خلال {{count}} يوم",
scheduleWithin_zero: "جدولة فحص اليوم",
scheduleWithin_one: "جدولة فحص خلال يوم واحد",
scheduleWithin_two: "جدولة فحص خلال يومين",
scheduleWithin_few: "جدولة فحص خلال {{count}} أيام",
scheduleWithin_many: "جدولة فحص خلال {{count}} يومًا",
scheduleWithin_other: "جدولة فحص خلال {{count}} يوم",
scheduleWithinDetail: "تحقّق من الحالة والتقط الأدلة في الموقع.",
openAssetRecord: "فتح سجل الأصل",
openAssetRecordDetail: "راجع السجل والمهام المرتبطة ونتائج آخر فحص.",
scheduleInspection: "جدولة فحص",
benefitDowntime: "تقليل خطر التوقف عن العمل",
benefitCatchDefects: "اكتشاف العيوب قبل حدوث العطل",
effortFailureUrgent: "منخفض — أسند المهمة إلى فني وافحص حالة مانع التسرب",
effortFailure: "منخفض — عيّن مسؤولًا وتأكّد من نطاق قائمة التحقق",
triageOverdue: "فرز المهام المتأخرة اليوم",
triageOverdueDetail: "أعد ترتيب الأولويات أو أعد الإسناد أو حدّث تواريخ الاستحقاق.",
escalateBlockers: "تصعيد العوائق",
escalateBlockersDetail: "أبرز المهام التي تنتظر قطعًا أو إمكانية وصول أو موافقات.",
today: "اليوم",
benefitSla: "استعادة الالتزام بـ SLA والحد من تراكم الأعمال",
effortOverdue: "متوسط — راجع المكلَّفين وتواريخ الاستحقاق عبر المجموعة",
renewCertificate: "تجديد الشهادة قبل انتهاء صلاحيتها",
renewCertificateDetail: "احجز التصديق أو فحص الامتثال قبل انقضاء الصلاحية.",
openCompliance: "فتح مساحة الامتثال",
openComplianceDetail: "تأكّد من المسؤولين وتواريخ التجديد لكل أصل.",
beforeExpiry: "قبل انتهاء الصلاحية (30 يومًا)",
benefitCompliance: "تجنّب انقضاء الامتثال والتعرّض لملاحظات التدقيق",
effortCompliance: "منخفض — تأكّد من مسؤول التجديد وتواريخ الاستحقاق",
reviewReopened: "مراجعة المهام المُعاد فتحها وتخصيص تدريب",
reviewReopenedDetail: "راجع حالات الفشل المتكررة مع الفني في الفئات المتأثرة.",
viewContacts: "عرض جهات الاتصال",
viewContactsDetail: "تحقّق من عبء العمل وإقران الفنيين للمتابعة التصحيحية.",
thisWeek: "هذا الأسبوع",
benefitRework: "تقليل إعادة العمل المتكررة وتحسين نسبة الإصلاح من المرة الأولى",
effortTraining: "متوسط — قدّم التدريب على أنماط الفئات وتحقّق من معايير الإغلاق",
createJob: "إنشاء مهمة",
scheduleOverdue: "جدولة فحوصات للأصول المتأخرة",
scheduleOverdueDetail: "سُدّ فجوة التغطية البالغة 90 يومًا بقوائم تحقق من قوائم التحقق.",
openInspections: "فتح مساحة الفحوصات",
openInspectionsDetail: "جدول الفحوصات دفعة واحدة أو ابدأ من مركز الفحوصات.",
benefitCoverage: "استعادة تغطية الفحص ووضوح المخاطر",
effortInspection: "منخفض — اختر قائمة تحققًا وعيّن المفتشين",
reviewPattern: "مراجعة النمط المتكرر",
inspectRelated: "فحص الأصول ذات الصلة",
inspectRelatedDetail: "تفقّد أصول المجموعة وتحقّق من طريقة الإصلاح والقطع ونطاق قائمة التحقق.",
reviewSupporting: "مراجعة المهام والفحوصات الداعمة",
reviewSupportingDetail: "تأكّد من الأدلة قبل تغيير المعايير.",
patternWindow: "النمط · {{value}}",
benefitCycles: "كسر حلقات الفشل المتكرر وتقليل إعادة العمل",
effortRootCause: "متوسط — قارن بين المهام والفحوصات وسجل الإصلاحات",
viewJobs: "عرض المهام",
startAssignedJob: "فتح المهمة المُسندة وبدء العمل عليها",
dueWindow: "الاستحقاق · {{value}}",
whenDue: "عند الاستحقاق",
benefitOnTrack: "إبقاء العمل المُسند على المسار الصحيح",
effortNextJob: "منخفض — افتح المهمة وانشر أول تحديث",
openJob: "فتح المهمة",
},
};
